import React from 'react';
import { WorldSettings } from './WorldSettings';

/**
 * 设定管理页 = 作品设定。
 *
 * 原本这里还有第二个标签「卷目结构」，现已移除：那一页真正独有的能力是
 * **节奏审视**（短章/长章筛选、每章字数分层），而它属于**章节列表**
 * （见 `workspace/components/ChapterTree.tsx` 的节奏视图开关）——
 * 把"列表"类的功能挂在「设定管理」下，既与侧栏的章节列表重名、又让用户找错地方。
 * 它原有的"摘要编辑"也已去掉：编辑器工具栏的「章节摘要」本就能改，无需两处入口。
 *
 * 于是这里只剩单页内容，连标签栏都不再需要。
 */
export function SettingsManager() {
  return (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'var(--bg-color)',
      color: 'var(--text-color)',
    }}>
      <WorldSettings />
    </div>
  );
}
